import { EPaginationParams } from 'features/Pagination';
import { baseApi as api } from 'shared/api/baseApi';
const injectedRtkApi = api.injectEndpoints({
	endpoints: (build) => ({
		/************** Don't change this endpoint **************/
		/*******************************************************/
		clientOffersList: build.query<ClientOffersListApiResponse, string>(
			{
				query: (params) => ({
					url: `/api/client/offers/${params ? '?' : ''}${params}`,
				}),
				serializeQueryArgs: ({ endpointName }) => {
					return endpointName;
				},
				merge: (cache, response, otherArgs) => {
					const offset = new URLSearchParams(otherArgs.arg).get(EPaginationParams.OFFSET);
					return !offset
						? response
						: {
							...response,
							results: [...(cache.results || []), ...(response.results || [])],
						};
				},
				forceRefetch({ currentArg, previousArg }) {
					return currentArg !== previousArg;
				},
			}),
		/*******************************************************/

		/************** Don't change this endpoint **************/
		/*******************************************************/
		clientOffersCreate: build.mutation<ClientOffersCreateApiResponse, FormData>({
			query: (formData) => ({ url: `/api/client/offers/`, method: 'POST',
				body: formData, }),
		}),
		/*******************************************************/
		clientOffersAttachmentsList: build.query<ClientOffersAttachmentsListApiResponse, ClientOffersAttachmentsListApiArg>(
			{
				query: (queryArg) => ({
					url: `/api/client/offers/${queryArg.offerId}/attachments/`,
					params: {
						limit: queryArg.limit,
						offset: queryArg.offset,
					},
				}),
			},
		),
		clientOffersAttachmentsCreate: build.mutation<
			ClientOffersAttachmentsCreateApiResponse,
			ClientOffersAttachmentsCreateApiArg
		>({
			query: (queryArg) => ({
				url: `/api/client/offers/${queryArg.offerId}/attachments/`,
				method: 'POST',
				body: queryArg.offerAttachmentCreateRequest,
			}),
		}),
		clientOffersAttachmentsDestroy: build.mutation<
			ClientOffersAttachmentsDestroyApiResponse,
			ClientOffersAttachmentsDestroyApiArg
		>({
			query: (queryArg) => ({
				url: `/api/client/offers/${queryArg.offerId}/attachments/${queryArg.id}/`,
				method: 'DELETE',
			}),
		}),
		clientOffersRetrieve: build.query<ClientOffersRetrieveApiResponse, ClientOffersRetrieveApiArg>({
			query: (queryArg) => ({ url: `/api/client/offers/${queryArg}/` }),
		}),
		clientOffersUpdate: build.mutation<ClientOffersUpdateApiResponse, ClientOffersUpdateApiArg>({
			query: (queryArg) => ({
				url: `/api/client/offers/${queryArg.id}/`,
				method: 'PUT',
				body: queryArg.offerUpdateValidatorRequest,
			}),
		}),
		clientOffersPartialUpdate: build.mutation<ClientOffersPartialUpdateApiResponse, ClientOffersPartialUpdateApiArg>({
			query: (queryArg) => ({
				url: `/api/client/offers/${queryArg.id}/`,
				method: 'PATCH',
				body: queryArg.patchedOfferUpdateValidatorRequest,
			}),
		}),
		clientOffersArchiveCreate: build.mutation<ClientOffersArchiveCreateApiResponse, ClientOffersArchiveCreateApiArg>({
			query: (queryArg) => ({ url: `/api/client/offers/${queryArg}/archive/`, method: 'POST' }),
		}),
		clientOffersPublishCreate: build.mutation<ClientOffersPublishCreateApiResponse, ClientOffersPublishCreateApiArg>({
			query: (queryArg) => ({ url: `/api/client/offers/${queryArg}/publish/`, method: 'POST' }),
		}),
		clientOffersTasksList: build.query<ClientOffersTasksListApiResponse, ClientOffersTasksListApiArg>({
			query: (queryArg) => ({
				url: `/api/client/offers/${queryArg.id}/tasks/`,
				params: {
					category: queryArg.category,
					limit: queryArg.limit,
					offset: queryArg.offset,
					ordering: queryArg.ordering,
					status: queryArg.status,
				},
			}),
		}),
		clientTasksRetrieve: build.query<ClientTasksRetrieveApiResponse, ClientTasksRetrieveApiArg>({
			query: (queryArg) => ({ url: `/api/client/tasks/${queryArg}/` }),
		}),
		clientTasksUpdate: build.mutation<ClientTasksUpdateApiResponse, ClientTasksUpdateApiArg>({
			query: (queryArg) => ({
				url: `/api/client/tasks/${queryArg.id}/`,
				method: 'PUT',
				body: queryArg.taskUpdateValidatorRequest,
			}),
		}),
		clientTasksPartialUpdate: build.mutation<ClientTasksPartialUpdateApiResponse, ClientTasksPartialUpdateApiArg>({
			query: (queryArg) => ({
				url: `/api/client/tasks/${queryArg.id}/`,
				method: 'PATCH',
				body: queryArg.patchedTaskUpdateValidatorRequest,
			}),
		}),
		clientTasksAttachmentsList: build.query<ClientTasksAttachmentsListApiResponse, ClientTasksAttachmentsListApiArg>({
			query: (queryArg) => ({
				url: `/api/client/tasks/${queryArg.taskId}/attachments/`,
				params: {
					limit: queryArg.limit,
					offset: queryArg.offset,
				},
			}),
		}),
		clientTasksAttachmentsCreate: build.mutation<
			ClientTasksAttachmentsCreateApiResponse,
			ClientTasksAttachmentsCreateApiArg
		>({
			query: (queryArg) => ({
				url: `/api/client/tasks/${queryArg.taskId}/attachments/`,
				method: 'POST',
				body: queryArg.taskAttachmentCreateRequest,
			}),
		}),
		clientTasksCommentsList: build.query<ClientTasksCommentsListApiResponse, ClientTasksCommentsListApiArg>({
			query: (queryArg) => ({
				url: `/api/client/tasks/${queryArg.taskId}/comments/`,
				params: {
					limit: queryArg.limit,
					offset: queryArg.offset,
				},
			}),
		}),
		clientTasksCommentsCreate: build.mutation<ClientTasksCommentsCreateApiResponse, ClientTasksCommentsCreateApiArg>({
			query: (queryArg) => ({
				url: `/api/client/tasks/${queryArg.taskId}/comments/`,
				method: 'POST',
				body: queryArg.taskCommentRequest,
			}),
		}),
		clientTasksCommentsRetrieve: build.query<ClientTasksCommentsRetrieveApiResponse, ClientTasksCommentsRetrieveApiArg>(
			{
				query: (queryArg) => ({ url: `/api/client/tasks/${queryArg.taskId}/comments/${queryArg.id}/` }),
			},
		),
		clientTasksCommentsUpdate: build.mutation<ClientTasksCommentsUpdateApiResponse, ClientTasksCommentsUpdateApiArg>({
			query: (queryArg) => ({
				url: `/api/client/tasks/${queryArg.taskId}/comments/${queryArg.id}/`,
				method: 'PUT',
				body: queryArg.taskCommentRequest,
			}),
		}),
		clientTasksCommentsPartialUpdate: build.mutation<
			ClientTasksCommentsPartialUpdateApiResponse,
			ClientTasksCommentsPartialUpdateApiArg
		>({
			query: (queryArg) => ({
				url: `/api/client/tasks/${queryArg.taskId}/comments/${queryArg.id}/`,
				method: 'PATCH',
				body: queryArg.patchedTaskCommentRequest,
			}),
		}),
		clientTasksCommentsDestroy: build.mutation<ClientTasksCommentsDestroyApiResponse, ClientTasksCommentsDestroyApiArg>(
			{
				query: (queryArg) => ({
					url: `/api/client/tasks/${queryArg.taskId}/comments/${queryArg.id}/`,
					method: 'DELETE',
				}),
			},
		),
		clientTasksTimelineList: build.query<ClientTasksTimelineListApiResponse, ClientTasksTimelineListApiArg>({
			query: (queryArg) => ({
				url: `/api/client/tasks/${queryArg.taskId}/timeline/`,
				params: {
					limit: queryArg.limit,
					offset: queryArg.offset,
				},
			}),
		}),
	}),
	overrideExisting: false,
});
export { injectedRtkApi as enhancedApi };
export type ClientOffersListApiResponse = /** status 200  */ PaginatedOfferListListRead;
export type ClientOffersListApiArg = {
	/** Filter offers by category */
	category?: string;
	/** Number of results to return per page. */
	limit?: number;
	/** The initial index from which to return the results. */
	offset?: number;
	/** Order results by field. Prefix with '-' for descending order. Available fields: created_at, deadline, price, name. Default: -created_at */
	ordering?: string;
	/** Filter offers by status */
	status?: string;
	/** Filter offers by type (public or private) */
	type?: string;
};
export type ClientOffersCreateApiResponse = /** status 201  */ OfferDetailsRead;
export type ClientOffersCreateApiArg = OfferCreateValidatorRequestWrite;
export type ClientOffersAttachmentsListApiResponse = /** status 200  */ PaginatedOfferAttachmentListRead;
export type ClientOffersAttachmentsListApiArg = {
	/** Number of results to return per page. */
	limit?: number;
	offerId: string;
	/** The initial index from which to return the results. */
	offset?: number;
};
export type ClientOffersAttachmentsCreateApiResponse = /** status 201  */ OfferAttachmentRead;
export type ClientOffersAttachmentsCreateApiArg = {
	offerId: string;
	offerAttachmentCreateRequest: OfferAttachmentCreateRequest;
};
export type ClientOffersAttachmentsDestroyApiResponse = unknown;
export type ClientOffersAttachmentsDestroyApiArg = {
	id: string;
	offerId: string;
};
export type ClientOffersRetrieveApiResponse = /** status 200  */ OfferDetailsRead;
export type ClientOffersRetrieveApiArg = string;
export type ClientOffersUpdateApiResponse = /** status 200  */ OfferDetailsRead;
export type ClientOffersUpdateApiArg = {
	id: string;
	offerUpdateValidatorRequest: OfferUpdateValidatorRequest;
};
export type ClientOffersPartialUpdateApiResponse = /** status 200  */ OfferDetailsRead;
export type ClientOffersPartialUpdateApiArg = {
	id: string;
	patchedOfferUpdateValidatorRequest: PatchedOfferUpdateValidatorRequest;
};
export type ClientOffersArchiveCreateApiResponse = /** status 200  */ OfferDetailsRead;
export type ClientOffersArchiveCreateApiArg = string;
export type ClientOffersPublishCreateApiResponse = /** status 200  */ OfferDetailsRead;
export type ClientOffersPublishCreateApiArg = string;
export type ClientOffersTasksListApiResponse = /** status 200  */ PaginatedTaskListListRead;
export type ClientOffersTasksListApiArg = {
	/** Filter tasks by category */
	category?: string;
	id: string;
	/** Number of results to return per page. */
	limit?: number;
	/** The initial index from which to return the results. */
	offset?: number;
	/** Order results by field. Prefix with '-' for descending order. Available fields: created_at, deadline, price, name. Default: -created_at */
	ordering?: string;
	/** Filter tasks by status */
	status?: string;
};
export type ClientTasksRetrieveApiResponse = /** status 200  */ TaskDetailsRead;
export type ClientTasksRetrieveApiArg = string;
export type ClientTasksUpdateApiResponse = /** status 200  */ TaskDetailsRead;
export type ClientTasksUpdateApiArg = {
	id: string;
	taskUpdateValidatorRequest: TaskUpdateValidatorRequest;
};
export type ClientTasksPartialUpdateApiResponse = /** status 200  */ TaskDetailsRead;
export type ClientTasksPartialUpdateApiArg = {
	id: string;
	patchedTaskUpdateValidatorRequest: PatchedTaskUpdateValidatorRequest;
};
export type ClientTasksAttachmentsListApiResponse = /** status 200  */ PaginatedTaskAttachmentCreateListRead;
export type ClientTasksAttachmentsListApiArg = {
	/** Number of results to return per page. */
	limit?: number;
	/** The initial index from which to return the results. */
	offset?: number;
	taskId: string;
};
export type ClientTasksAttachmentsCreateApiResponse = /** status 201  */ TaskAttachmentCreateRead;
export type ClientTasksAttachmentsCreateApiArg = {
	taskId: string;
	taskAttachmentCreateRequest: TaskAttachmentCreateRequest;
};
export type ClientTasksCommentsListApiResponse = /** status 200  */ PaginatedTaskCommentListRead;
export type ClientTasksCommentsListApiArg = {
	/** Number of results to return per page. */
	limit?: number;
	/** The initial index from which to return the results. */
	offset?: number;
	taskId: string;
};
export type ClientTasksCommentsCreateApiResponse = /** status 201  */ TaskCommentRead;
export type ClientTasksCommentsCreateApiArg = {
	taskId: string;
	taskCommentRequest: TaskCommentRequest;
};
export type ClientTasksCommentsRetrieveApiResponse = /** status 200  */ TaskCommentRead;
export type ClientTasksCommentsRetrieveApiArg = {
	id: string;
	taskId: string;
};
export type ClientTasksCommentsUpdateApiResponse = /** status 200  */ TaskCommentRead;
export type ClientTasksCommentsUpdateApiArg = {
	id: string;
	taskId: string;
	taskCommentRequest: TaskCommentRequest;
};
export type ClientTasksCommentsPartialUpdateApiResponse = /** status 200  */ TaskCommentRead;
export type ClientTasksCommentsPartialUpdateApiArg = {
	id: string;
	taskId: string;
	patchedTaskCommentRequest: PatchedTaskCommentRequest;
};
export type ClientTasksCommentsDestroyApiResponse = unknown;
export type ClientTasksCommentsDestroyApiArg = {
	id: string;
	taskId: string;
};
export type ClientTasksTimelineListApiResponse = /** status 200  */ PaginatedTimelineEventListRead;
export type ClientTasksTimelineListApiArg = {
	/** Number of results to return per page. */
	limit?: number;
	/** The initial index from which to return the results. */
	offset?: number;
	taskId: string;
};
export type OfferList = {};
export type OfferListRead = {
	id: string;
	name: string;
	description: string;
	category: string;
	status: string;
	type: string;
	price: string;
	deadline: string;
	created_at: string;
};
export type PaginatedOfferListList = {
	count: number;
	next?: string | null;
	previous?: string | null;
	results: OfferList[];
};
export type PaginatedOfferListListRead = {
	count: number;
	next?: string | null;
	previous?: string | null;
	results: OfferListRead[];
};
export type OfferDetails = {
	name: string;
	description: string;
	category: string;
	price: string;
	deadline?: string | null;
};
export type OfferOwner = {};
export type OfferOwnerRead = {
	id: string;
	username: string;
	email: string;
};
export type OfferAttachment = {};
export type OfferAttachmentRead = {
	id: string;
	file: string;
	created_at: string;
};
export type OfferDetailsRead = {
	id: string;
	name: string;
	description: string;
	category: string;
	status: string;
	type: string;
	price: string;
	deadline?: string | null;
	published_at: string;
	owner: OfferOwnerRead;
	attachments: OfferAttachmentRead[];
	created_at: string;
	updated_at: string;
};
export type OfferCreateValidatorRequest = {};
export type OfferCreateValidatorRequestWrite = {
	name: string;
	description: string;
	category: CategoryEnum;
	price: string;
	deadline?: string | null;
	type: OfferCreateValidatorTypeEnum;
	contractor_email?: string | null;
	attachments?: Blob[];
};
export type PaginatedOfferAttachmentList = {
	count: number;
	next?: string | null;
	previous?: string | null;
	results: OfferAttachment[];
};
export type PaginatedOfferAttachmentListRead = {
	count: number;
	next?: string | null;
	previous?: string | null;
	results: OfferAttachmentRead[];
};
export type OfferAttachmentCreateRequest = {
	file: Blob;
};
export type OfferUpdateValidatorRequest = {
	name: string;
	description: string;
	category: CategoryEnum;
	price: string;
	deadline?: string | null;
};
export type PatchedOfferUpdateValidatorRequest = {
	name?: string;
	description?: string;
	category?: CategoryEnum;
	price?: string;
	deadline?: string | null;
};
export type TaskList = {};
export type TaskOwner = {};
export type TaskOwnerRead = {
	id: string;
	username: string;
	email: string;
};
export type TaskContractor = {};
export type TaskContractorRead = {
	id: string;
	username: string;
	email: string;
};
export type TaskListRead = {
	id: string;
	offer_id: string;
	name: string;
	description: string;
	category: string;
	status: string;
	price: string;
	deadline: string;
	owner: TaskOwnerRead;
	contractor: TaskContractorRead;
};
export type PaginatedTaskListList = {
	count: number;
	next?: string | null;
	previous?: string | null;
	results: TaskList[];
};
export type PaginatedTaskListListRead = {
	count: number;
	next?: string | null;
	previous?: string | null;
	results: TaskListRead[];
};
export type TaskDetails = {};
export type TaskAttachment = {};
export type TaskAttachmentRead = {
	id: string;
	file: string;
	created_at: string;
};
export type TaskDetailsRead = {
	id: string;
	offer_id: string;
	name: string;
	description: string;
	category: string;
	status: string;
	price: string;
	deadline: string;
	published_at: string;
	owner: TaskOwnerRead;
	contractor: TaskContractorRead;
	attachments: TaskAttachmentRead[];
	created_at: string;
	updated_at: string;
};
export type TaskUpdateValidatorRequest = {
	price: string;
	deadline?: string | null;
};
export type PatchedTaskUpdateValidatorRequest = {
	price?: string;
	deadline?: string | null;
};
export type TaskAttachmentCreate = {
	file: string;
};
export type TaskAttachmentCreateRead = {
	id: string;
	file: string;
	task_id: string;
};
export type PaginatedTaskAttachmentCreateList = {
	count: number;
	next?: string | null;
	previous?: string | null;
	results: TaskAttachmentCreate[];
};
export type PaginatedTaskAttachmentCreateListRead = {
	count: number;
	next?: string | null;
	previous?: string | null;
	results: TaskAttachmentCreateRead[];
};
export type TaskAttachmentCreateRequest = {
	file: Blob;
};
export type TaskComment = {
	content: string;
};
export type TaskCommentAuthor = {};
export type TaskCommentAuthorRead = {
	id: string;
	username: string;
	email: string;
	full_name: string;
};
export type TaskCommentRead = {
	id: string;
	task_id: string;
	author: TaskCommentAuthorRead;
	content: string;
	created_at: string;
	updated_at: string;
};
export type PaginatedTaskCommentList = {
	count: number;
	next?: string | null;
	previous?: string | null;
	results: TaskComment[];
};
export type PaginatedTaskCommentListRead = {
	count: number;
	next?: string | null;
	previous?: string | null;
	results: TaskCommentRead[];
};
export type TaskCommentRequest = {
	content: string;
};
export type PatchedTaskCommentRequest = {
	content?: string;
};
export type TimelineEvent = {};
export type TimelineEventRead = {
	type: TimelineEventTypeEnum;
	created_at: string;
	// Don't change this endpoint
	/*******************************************************/
	/** Event-specific data. Structure depends on the event type. */
	data: {
		price?: number | string | null;
		deadline?: string | null;
		comment_id?: string;
	};
	/*******************************************************/
	comment: TaskCommentRead | null;
};
export type PaginatedTimelineEventList = {
	count: number;
	next?: string | null;
	previous?: string | null;
	results: TimelineEvent[];
};
export type PaginatedTimelineEventListRead = {
	count: number;
	next?: string | null;
	previous?: string | null;
	results: TimelineEventRead[];
};
export enum CategoryEnum {
	SocialMedia = 'social_media',
	VideoProduction = 'video_production',
	InfluencerMarketing = 'influencer_marketing',
	EmailMarketing = 'email_marketing',
	WebsitePlacements = 'website_placements',
	NativeAdvertisement = 'native_advertisement',
	ContentCreation = 'content_creation',
	Affiliate = 'affiliate',
	Other = 'other',
}
export enum OfferCreateValidatorTypeEnum {
	Public = 'public',
	Private = 'private',
}
export enum TimelineEventTypeEnum {
	TaskAccepted = 'task_accepted',
	TaskUpdated = 'task_updated',
	TaskStarted = 'task_started',
	SentForReview = 'sent_for_review',
	TaskCompleted = 'task_completed',
	TaskRejected = 'task_rejected',
	CommentCreated = 'comment_created',
}
